import { render, staticRenderFns } from "./ColumnsSelect.vue?vue&type=template&id=669e4048"
import script from "./ColumnsSelect.vue?vue&type=script&lang=js"
export * from "./ColumnsSelect.vue?vue&type=script&lang=js"
import style0 from "./ColumnsSelect.vue?vue&type=style&index=0&id=669e4048&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports